import { createServerLogger } from "@web-store-platforms/utils";
import { LoggerEventNames } from "../consts/logger";

/**
 * Writes to stdout/stderr, which the cluster's OTel agent ships to Coralogix as
 * prod/store. The previous implementation pushed over HTTP with a private key the
 * Dockerfile never passes, and its initialize() was never called from anywhere, so
 * every call returned early and the store had no server-side telemetry at all.
 */
export const serverLogger = createServerLogger<LoggerEventNames>();
